// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__11oUi","itemTitle":"ClientEmergencyInfo_itemTitle__1l_Dc","itemText":"ClientEmergencyInfo_itemText__3raFg"};